export default function dataURItoBlob(dataURI, filename = null) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(",")[0].indexOf("base64") >= 0)
    byteString = atob(dataURI.split(",")[1]);
  else byteString = unescape(dataURI.split(",")[1]);

  // separate out the mime component
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  var extension = mimeString.split('/')[1] || 'png';
  if (!filename) {
    filename = `image_${Date.now()}.${extension}`;
  }

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // Return a File object with a name
  return new File([ia], filename, { type: mimeString });
}
